<template>
  <v-container v-if="usuariosCargados">
    <v-btn color="orange" @click="volver" class="ma-2 white--text">
      Volver
    </v-btn>
    <v-btn
      color="orange"
      dark
      class="ma-2 white--text"
      style="float:right;"
      @click="sucesosRegistradosGlobales"
    >
      Registros Globales
    </v-btn>
    <br><br>
    <v-data-table
      :headers="columnas"
      :items="arrayUsuarios"
      :search="buscar"
      :loading="cargando"
      :sort-by.sync="valorQueOrdenaLaTabla"
      :sort-desc.sync="tipoDeOrdenacion"
      :page="pagina"
      item-key="correo"
      class="elevation-1"
      no-data-text="No hay datos disponibles"
      :footer-props="{
        'items-per-page-text':'Filas por pagina',
      }"
    >
      <template v-slot:item.bloqueado="{ item }">
        <v-icon v-if="item.bloqueado">mdi-lock-outline</v-icon>
      </template>
      <template v-slot:item.compartir="{ item }">
        <v-icon v-if="item.compartir">mdi-check</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="mx-2" @click="sucesosRegistradosUsuarios(item.correo)">mdi-eye</v-icon>
        <v-icon class="mx-2" @click="editarUsuario(item.correo)">mdi-pencil</v-icon>
        <v-icon class="mx-2" @click="eliminarUsuario(item.correo)">mdi-delete</v-icon>
      </template>
      <!-- <template v-slot:body="{ items } " >
        <tbody>
          <tr v-for="item in items" :key="item.correo"  @dblclick="editarUsuario(item.correo)">
            <td>{{ item.nombre }}</td>
            <td>{{ item.correo }}</td>
            <td>
              <v-icon v-if="item.bloqueado">mdi-lock-outline</v-icon>
            </td>
            <td>
              <v-icon v-if="item.compartir">mdi-check</v-icon>
            </td>
            <td>
              {{ item.nombreGrupo }}
            </td>
            <td>
              {{item.fecha_alta}}
            </td>
            <td>
              <v-icon @click="sucesosRegistradosUsuarios(item.correo)">mdi-eye</v-icon>
              <v-icon @click="editarUsuario(item.correo)">mdi-pencil</v-icon>
              <v-icon @click="eliminarUsuario(item.correo)">mdi-delete</v-icon>
            </td>
          </tr>
        </tbody>
      </template> -->
      <template v-slot:top>
        <v-row  class="hidden-md-and-up ml-1">
          <v-col  cols="12">
            <v-toolbar-title>Usuarios</v-toolbar-title>
          </v-col>
          <v-col cols="12">
            <v-btn dark color="orange"  @click="nuevoUsuario">Nuevo Usuario</v-btn>
          </v-col>
          <v-col cols="12" class="mb-2">
            <v-text-field
              v-model="buscar"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-toolbar flat class="hidden-sm-and-down">
          <v-toolbar-title>Usuarios</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="buscar"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn dark color="orange" @click="nuevoUsuario">Nuevo Usuario</v-btn>
        </v-toolbar>
      </template>
    </v-data-table>
    <v-data-table
      style="margin-top: 40px; margin-bottom:100px"
      :headers="columnasGruposAccesos"
      :items="arrayGruposAccesos"
      :search="buscarGrupo"
      :loading="cargando"
      item-key="id"
      class="elevation-1"
      no-data-text="No hay datos disponibles"
      :footer-props="{
        'items-per-page-text':'Filas por pagina',
      }"

    >
    <template v-slot:item.actions="{ item }">
      <v-icon

        class="mx-2"
        @click="editarGrupoAcceso(item.id)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        class="mx-2"
        @click="eliminarGrupoAcceso(item.id, item.nombre)"
      >
        mdi-delete
      </v-icon>
    </template>
      <!-- <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id" @dblclick="editarGrupoAcceso(item.id)" >
            <td>{{ item.id }}</td>
            <td>{{ item.nombre }}</td>
            <td>{{ item.descripcion }}</td>
            <td>
              <v-icon @click="editarGrupoAcceso(item.id)">mdi-pencil</v-icon>
              <v-icon @click="eliminarGrupoAcceso(item.id, item.nombre)">mdi-delete</v-icon>
            </td>
          </tr>
        </tbody>
      </template> -->
      <template v-slot:top>
        <v-row  class="hidden-md-and-up ml-1">
          <v-col  cols="12">
            <v-toolbar-title>Grupos Usuarios</v-toolbar-title>
          </v-col>
          <v-col  cols="12">
            <v-btn dark color="orange" @click="nuevoGrupoAccesos"
              >Nuevo Grupo</v-btn
            >
          </v-col>
          <v-col cols="12" class="mb-2">
            <v-text-field
              v-model="buscarGrupo"
              append-icon="mdi-magnify"
              label="Buscar"
              class="mr-2"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-toolbar flat class="hidden-sm-and-down" >
          <v-toolbar-title>Grupos Usuarios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="buscarGrupo"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn dark color="orange" @click="nuevoGrupoAccesos"
            >Nuevo Grupo</v-btn
          >
        </v-toolbar>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
export default {
  data() {
    return {
      columnas: [
        { text: "Nombre", value: "nombre", filterable: true },
        { text: "Usuario", value: "correo", filterable: true },
        { text: "Bloqueado", value: "bloqueado", filterable: false },
        { text: "Compartir Archivo", value: "compartir", filterable: false },
        { text: "Permiso", value: "nombreGrupo", filterable: false },
        { text: "Fecha de Acceso", value: "fechaAcceso", filterable: false },
        { text: "Acciones", value: "actions", filterable: false },
      ],
      columnasGruposAccesos: [
        { text: "Nombre", value: "nombre", filterable: true },
        { text: "Descripcion", value: "descripcion", filterable: true },
        { text: "Acciones", value: "actions", filterable: false },
      ],
      arrayUsuarios: [],
      arrayGruposAccesos: [],
      buscar: "",
      cargando: false,
      usuariosCargados: false,
      buscarGrupo: "",
      pagina: parseInt(this.$estadoApp.pagina),
      tipoDeOrdenacion: false,
      valorQueOrdenaLaTabla:'correo'
    };
  },
  methods: {
    //Obtenemos todos los usuarios
    obtenerUsuarios() {
      this.cargando = true;
      ApiZD.obtenerUsuarios()
        .then((resultado) => {
          this.completarArrayConElNombreDelGrupoDeAcceso(resultado.data.usuarios);
        })
        .catch((e) => {
          this.$router.push({ path: "/principal" });
        })
        .finally(() => {
          this.usuariosCargados = true;
          this.cargando = false;
        });
    },

    obtenerGruposAccesosDeUsuarios() {
      ApiZD.obtenerGrupoAccesos()
        .then((resultado) => {
          this.arrayGruposAccesos = resultado.data.grupos;
          this.obtenerUsuarios();
        })
        .catch((e) => {
          this.$router.push({ path: "/principal" });
        })
        .finally(() => {});
    },
    //Completamos el array con el nombre del grupo de acceso
    completarArrayConElNombreDelGrupoDeAcceso(arrayUsuariosSinCompletar){
      arrayUsuariosSinCompletar.forEach((usuario) =>{
        if(usuario['id_grupo'] != "Administrador" ){
          this.arrayGruposAccesos.forEach((grupo) =>{
            if(grupo['id'] == usuario['id_grupo'])
              usuario['nombreGrupo'] = grupo['nombre'];
          })
        }else{
          usuario['nombreGrupo'] = "Administrador"
        }
      })
      this.arrayUsuarios = arrayUsuariosSinCompletar;
    },

    //Obtenemos la posicion del elemento en la tabla que se editado por ultima vez. Cuando lo obtenemos lo establecemos en la variable pagina para que la tabla vaya hasta esa posicion
    obtenerPosicionEnLaTablaDelUltimoElementoVisitado(correo){
      //Obtenemos la posicion del array
      let indice = this.arrayUsuarios.findIndex(usuario => usuario.correo == correo);

      //Calculamos la pagina en la que se encuentra y se la asignamos a la variable
      let pagina = Math.trunc(indice/10);
      this.$estadoApp.pagina = pagina + 1;
    },

    //Eliminamos usuario
    eliminarUsuario(correo) {
      this.$root.$dialogo
        .activarDialogo("Confirmación ", "¿Deseas eliminar el usuario " + correo + "?", [
          "Si",
          "No",
        ])
        .then((res) => {
          if (res == 0) {
            //Eliminamos al usuario y actualizamos tabla
            ApiZD.eliminarUsuario(correo).then(() => {
              this.obtenerUsuarios();
            });
          }
        })
        .catch((e) => {

        });
    },

    //Eliminar un grupo de accesos
    eliminarGrupoAcceso(id , nombre) {
      this.$root.$dialogo
        .activarDialogo("Confirmación ", "¿Deseas eliminar el grupo de usuarios " +  nombre + "?", [
          "Si",
          "No",
        ])
        .then((res) => {
          if (res == 0) {
            //Eliminamos el grupo y actualizamos tabla
            ApiZD.eliminarGrupoAccesos(id).then(() => {
              this.obtenerGruposAccesosDeUsuarios();
            });
          }
        })
        .catch((e) => {

        });
    },

    volver() {
      this.$router.push({ path: "/principal" });
    },

    sucesosRegistradosGlobales(){
      this.$router.push({ path: "/sucesosGlobales"});
    },

    sucesosRegistradosUsuarios(correo) {
      this.obtenerPosicionEnLaTablaDelUltimoElementoVisitado(correo);
      this.$router.push({ path: "/sucesosRegistradosUsuario/" + correo });
    },

    //Entramos en la pagina para editar al usuario
    editarUsuario(correo) {
      this.obtenerPosicionEnLaTablaDelUltimoElementoVisitado(correo);
      this.$router.push({ path: "/gestionUsuario/" + correo });
    },

    editarGrupoAcceso(id) {
      this.$router.push({ path: "/gestionGrupoAccesos/" + id });
    },

    //Entramos en la pagina para crear al usuario
    nuevoUsuario() {
      this.$router.push({ path: "/nuevoUsuario" });
    },

    nuevoGrupoAccesos() {
      this.$router.push({ path: "/nuevoGrupoAccesos" });
    },
  },
  created() {
    if(!isNaN(this.pagina))
      this.pagina = parseInt(this.$estadoApp.pagina);
    else
      this.pagina = 1;

    this.obtenerGruposAccesosDeUsuarios();
  },
};
</script>

<style>
</style>